import { render } from "./Landing.vue?vue&type=template&id=0e058064&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=0e058064&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e058064"

export default script